import React from 'react';

import { Form, Checkbox } from 'antd';
import { FormItemProps } from 'antd/lib/form/FormItem';

export interface CheckboxFormItemProps extends FormItemProps {
  checkboxLabel?: React.ReactNode;
  disabled?: boolean;
  /** Runs after the form value updates. */
  onChange?: (checked: boolean) => void;
}

export const CheckboxFormItem = ({
  checkboxLabel,
  disabled = false,
  onChange,
  ...props
}: CheckboxFormItemProps): JSX.Element => (
  <Form.Item {...props} valuePropName="checked">
    <Checkbox disabled={disabled} onChange={(event) => onChange?.(event.target.checked)}>
      {checkboxLabel}
    </Checkbox>
  </Form.Item>
);
